<template>
  <NuxtLink :to="resolvedHref" class="category-card" :style="{ '--bg-color': bgColor }">
    <div class="category-image">
      <picture class="img-desktop">
        <source type="image/webp" :srcset="`${imageWebpX1} 1x, ${imageWebp} 2x`">
        <img :src="image" :alt="imageAlt" width="300" height="261" loading="lazy" decoding="async">
      </picture>
      <picture class="img-mobile">
        <source type="image/webp" :srcset="`${imageMobileWebpX1} 435w, ${imageMobileWebp} 870w`" sizes="calc(100vw - 40px)">
        <img :src="imageMobile" :alt="imageMobileAlt" width="425" height="213" loading="lazy" decoding="async">
      </picture>
    </div>
    <span class="category-title">{{ title }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
const route = useRoute()
const { locale } = useI18n()

const currentLocale = computed(() => (route.params.locale ?? locale.value) as string)

interface Props {
  title: string
  image: string
  imageMobile: string
  imageAlt: string
  imageMobileAlt: string
  href?: string
  bgColor?: string
}

const props = withDefaults(defineProps<Props>(), {
  href: '',
  bgColor: '#E8F4FF'
})

const resolvedHref = computed(() => props.href || `/${currentLocale.value}/courses`)

const imageWebp = computed(() =>
  props.image.replace('/desktop/', '/desktop/webp/').replace(/\.jpg$/, '.webp'),
)
const imageWebpX1 = computed(() =>
  props.image.replace('/desktop/', '/desktop/webp/x1/').replace(/\.jpg$/, '.webp'),
)
const imageMobileWebp = computed(() =>
  props.imageMobile.replace('/mobile/', '/mobile/webp/').replace(/\.jpg$/, '.webp'),
)
const imageMobileWebpX1 = computed(() =>
  props.imageMobile.replace('/mobile/', '/mobile/webp/x1/').replace(/\.jpg$/, '.webp'),
)
</script>

<style scoped>
.category-card {
  display: block;
  text-decoration: none;
}

.category-image {
  width: 300px;
  height: 261px;
  border-radius: 15px;
  overflow: hidden;
  position: relative;
}

.category-image img,
.category-image picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.35s ease;
}

.category-image picture {
  display: block;
  width: 100%;
  height: 100%;
}

.category-image picture.img-mobile {
  display: none;
}

.img-mobile,
.img-mobile img {
  width: 100%;
  height: 100%;
}

@media (hover: hover) and (pointer: fine) {
  .category-card:hover .category-image img,
  .category-card:hover .category-image picture img {
    transform: scale(1.07);
  }
}

.category-title {
  display: block;
  margin-top: 16px;
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 19px;
  color: var(--color-dark-blue);
  text-align: center;
}
@media (max-width: 767px) {
  .category-card {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}

/* Мобільна версія */
@media (max-width: 480px) {
  .category-card {
    display: block;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
  }

  .category-title {
    position: absolute;
    top: 50%;
    left: 28px;
    transform: translateY(-50%);
    margin-top: 0;
    font-size: 28px;
    text-align: left;
    z-index: 1;
  }

  .category-image {
    width: 100%;
    height: auto;
    border-radius: 0;
    /* height: 166px; */
  }

  .category-image .img-desktop {
    display: none;
  }

  .category-image picture.img-mobile {
    display: block;
    width: 100%;
    height: auto;
  }

  .img-mobile img {
    height: auto;
    object-fit: contain;
  }
}
@media (max-width: 420px){
  .category-title {
    font-size: 22px;
} 
}
</style>
